import { Typography, Grid2 as Grid, Card, CardActionArea, CardContent } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { EmailContactModel } from "../../models/ContactModels";

interface Props {
  contacts: EmailContactModel[];
  type: "payables" | "receivables";
}

export function ContactList({ contacts, type }: Props) {
  const navigate = useNavigate();

  const onClickContact = (id: string) => {
    const path = type === "payables" ? `/payables/${id}` : `/receivables/${id}`;
    navigate(path);
  };

  const sortedContacts = [...contacts].sort((a, b) => a.companyName.localeCompare(b.companyName));

  return (
    <Grid container direction="column" spacing={2}>
      {sortedContacts.map((contact) => (
        <Grid key={contact.id} width="100%">
          <Card onClick={() => onClickContact(contact.id)}>
            <CardActionArea className="paper-style">
              <CardContent>
                <Typography
                  noWrap
                >{`${contact.accountNumber ? `${contact.accountNumber} | ` : ""}${contact.companyName}`}</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
